module.exports = __webpack_public_path__ + "img/SystemInformation-no-data.e2148052.png";